<template>
  <button
    class="add-to-locker-button"
    :disabled="isLockerLoading || isProjectLocked"
    :class="{
      disabled: isLockerLoading || isProjectLocked,
      'dealer-mode': dealerMode,
      'is-snapsheet': isSnapsheet,
    }"
    @click="$emit('addToLocker')"
  >
    <img src="@/assets/icons/ui/add-to-locker.png" alt="add to locker" />
  </button>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "AddToLockerButton",
  props: ["isProjectLocked"],
  computed: {
    ...mapState("auth", ["dealerMode"]),
    ...mapGetters("project", ["isSnapsheet"]),
    ...mapState(["lockerModule"]),

    isLockerLoading() {
      return this.lockerModule.loadingLocker;
    },
  },
};
</script>

<style lang="scss" >
.product, .product-info {
  &:hover {
    .add-to-locker-button {
      background-color: transparent;
      visibility: visible;
      transition: all 0.2s;
      transform: translateX(-0.5rem);
      &:hover {
        filter: drop-shadow( 0 0 2px $green); 
        /* transform: scale(1) !important; */
      }
    }
  }

  .add-to-locker-button {
    display: flex;
    width: fit-content;
    width: webkit-fit-content;
    visibility: hidden;
    background: none;
    position: absolute;
    top: 0.8rem;
    right: 1rem;
    cursor: pointer;
    transition: all 0.2s;
    z-index: 10;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed !important;
      img {
        opacity: 0.5;
      }
    }

    &.is-snapsheet{
      left: 1rem;
      right: 0;
    }
  }
}
</style>